import { useControllableValue } from 'ahooks';
import PresetDatePicker from './presetDatePicker';
import PresetDatePickerWidthController from './presetDatePickerWidthController';
import { jsx as _jsx } from "react/jsx-runtime";
export { getDefaultValue } from './utils';
const Component = props => {
  const [value, _onChange] = useControllableValue(props, {
    defaultValue: undefined,
    defaultValuePropName: 'defaultValue',
    valuePropName: 'value',
    trigger: 'onChange'
  });
  const onChange = v => {
    window.setTimeout(() => {
      _onChange(v);
    }, 300);
  };
  return props.playerControl ? /*#__PURE__*/_jsx(PresetDatePickerWidthController, {
    ...props,
    value: value,
    onChange: onChange
  }) : /*#__PURE__*/_jsx(PresetDatePicker, {
    ...props,
    value: value,
    onChange: onChange
  });
};
export default Component;
export * from './interface';